import React, { useState, useEffect } from "react";
import { Offcanvas, Button, Form } from "react-bootstrap";
import { FaUserCircle, FaArrowRight } from "react-icons/fa";
import "./hierarchy.css";
import { getApprovalLevels, approvalLevelUpdate } from "../../slices/hsnSacReducer";
import { useSelector, useDispatch } from "react-redux";

const RoleSelectionOffcanvas = ({ show, onHide }) => {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const dispatch = useDispatch();
  const roles = [
    { id: 5, name: "Research Team" },
    { id: 2, name: "Manager" },
    { id: 1, name: "Director" },
  ];
  const {
    approval_level_list,
    total_count,
    loading,
    error,
    success,
    successMsg,
  } = useSelector((state) => state.hsnSac);

  useEffect(() => {
    if (show) {
      dispatch(getApprovalLevels());
    }
  }, [show]);

  useEffect(() => {
    if (approval_level_list?.length > 0) {
      const approvedRoleIds = approval_level_list.map((item) => item.id);
      setSelectedRoles(approvedRoleIds);
    }
  }, [approval_level_list]);

  const handleCheckboxChange = (role) => {
    if (selectedRoles.includes(role)) {
      setSelectedRoles(selectedRoles.filter((r) => r !== role));
    } else {
      setSelectedRoles([...selectedRoles, role]);
    }
  };

  const handleUpdate = () => {
    console.log("Selected Roles:", selectedRoles);
    dispatch(approvalLevelUpdate({ approver_levels: selectedRoles }));
    onHide();
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="top"
      backdrop="static"
      className="role-selection-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Approval Hierarchy</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column">
        <div className="flex-grow-1">
          <div className="step-container-horizontal ">
            {roles.map((role, index) => (
              <div key={index} className="step-horizontal">
                <div className="step-icon">
                  <FaUserCircle size={24} style={{ color: "#0d4473" }} />
                </div>
                <div className="step-label">
                  <span>{role.name}</span>
                  <Form.Check
                    type="checkbox"
                    checked={selectedRoles.includes(role.id)} // Dynamically control checked state
                    onChange={() => handleCheckboxChange(role.id)}
                    className="custom-checkbox"
                  />
                </div>
                {index < roles.length - 1 && (
                  <div className="step-arrow-horizontal">
                    <FaArrowRight size={24} style={{ color: "#0d4473" }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        <div className="border-top pt-3 mt-3">
          <div className="d-flex gap-2 justify-content-end">
            <Button variant="secondary" onClick={onHide}>
              Close
            </Button>
            <Button variant="primary" disabled={selectedRoles.length === 0} onClick={handleUpdate}>
              Update
            </Button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default RoleSelectionOffcanvas;